import axios from 'axios';

export const PasswordRecovery = {
  async sendCode(payload) {
    const res = await axios.post('password_recovery/send_code/', payload);

    if (res.status === 200) {
      return res;
    }

    return Promise.reject();
  },
  async verifyCode(payload) {
    const res = await axios.post('password_recovery/code_verify/', payload);

    if (res.status === 200) {
      return res;
    }

    return Promise.reject();
  },
  async changePassword(payload) {
    const res = await axios.post('password_recovery/change_password/', payload);

    if (res.status === 200) {
      return res;
    }

    return Promise.reject();
  },
};
